if(!customElements.get('post-recommendations')) {
  customElements.define(
    'post-recommendations',
    class PostRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.initSlider();
      }

      initSlider() {
        if(!this.sliderEl) {
          return console.error('An error ocurred while trying to initialize post recommendations slider');
        }

        this.sliderInstance = new Swiper(this.sliderEl, {
          slidesPerView: 1.3,
          spaceBetween: 12,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 16
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 16
            }
          },
          navigation: {
            prevEl: '.post-recommendations-slider-button.slider-button.prev',
            nextEl: '.post-recommendations-slider-button.slider-button.next',
          },
          pagination: {
            el: '.post-recommendations-slider-pagination',
            type: 'bullets',
            clickable: true
          }
        });
      }
    }
  );
}